var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'no-event': _vm.disabled}},[_c('JoditVue',{attrs:{"id":_vm.id,"value":_vm.value ? _vm.value : '',"config":_vm.config},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }